
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { upload } from '@/api/attached-file';
import {
  // all extensions
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Link,
  Image,
  Blockquote,
  ListItem,
  BulletList, // use with ListItem
  OrderedList, // use with ListItem
  TodoItem,
  TodoList, // use with TodoItem
  TextAlign,
  Indent,
  HorizontalRule,
  HardBreak,
  History,
  // LineHeight,
  // Iframe,
  // CodeBlock,
  // TrailingNode,
  // Table, // use with TableHeader, TableCell, TableRow
  // TableHeader,
  // TableCell,
  // TableRow,
  // FormatClear,
  // TextColor,
  // TextHighlight,
  // Preview,
  // Print,
  Fullscreen,
  CodeView,
  // SelectAll,
} from 'element-tiptap';

@Component({
  components: {
  },
})
export default class extends Vue {
  @Prop({ default: '' }) private content!: string;

  @Prop({ default: '400px' }) private height!: string;

  @Prop({ default: '' }) private uploadUrl!: string;

  @Watch('content', { deep: true })
  private getCalendarInfo() {
    this.$nextTick(() => {
      this.editorValue = this.content;
    });
  }

  mounted() {
    this.$nextTick(() => {
      this.editorValue = this.content;
    });
  }

  private editorValue = '';

  private extensions = [
    new Doc(),
    new Text(),
    new Paragraph(),
    new Heading({ level: 5 }),
    new Bold({ bubble: true }),
    new Underline({ bubble: true }),
    new Italic({ bubble: true }),
    new Strike({ bubble: true }),
    new Link({ bubble: true }),
    new Image({
      uploadRequest: this.handleUploadImage,
    }),
    new Blockquote(),
    new TextAlign(),
    new ListItem(),
    new BulletList({ bubble: true }),
    new OrderedList({ bubble: true }),
    new TodoItem(),
    new TodoList(),
    new Indent(),
    new HardBreak(),
    new HorizontalRule({ bubble: true }),
    new Fullscreen(),
    new History(),
  ];

  private handleUpdateEditor(value: string) {
    this.$emit('change', value);
  }

  private handleUploadImage(file: any, b: any) {
    return new Promise((resolve, reject) => {
      if (file.type.indexOf('image') < 0) {
        this.$message.warning('이미지 파일만 업로드 가능합니다.');
        reject();
      } else if (file.size / 1024 / 1024 > 10) {
        this.$message.warning('10MB까지 업로드 가능합니다.');
        reject();
      }
      const formData = new FormData();
      formData.append('file', file);
      upload(this.uploadUrl, formData).then((res) => {
        const imageUrl = `/api/attached-file/${res.data.uid}`;
        resolve(imageUrl);
      }).catch(() => {
        this.$message.error('이미지를 업로드 하는데 실패했습니다.');
        reject();
      });
    });
  }
}
